<template>
  <v-card :loading="loading">
    <v-card-title>
      <slot name="header"></slot>
    </v-card-title>
    <v-card-subtitle>
      <slot name="subheader"></slot>
    </v-card-subtitle>
    <v-divider></v-divider>
    <v-card-text>
      <v-container v-if="items.length > 0" fluid>
        <v-row v-for="(schedule, i) in items" :key="i">
          <v-col cols="12" md="3">
            <div class="mb-2">
              <v-icon left small>mdi-calendar-today</v-icon>
              <strong>
                {{ formatDate(schedule.class_date, 'DD MMM YYYY') }}
              </strong>
              <v-chip
                small
                :class="{
                  'mx-1': !$vuetify.breakpoint.mobile,
                  'float-right': $vuetify.breakpoint.mobile,
                }"
              >
                {{ timeFromNow(schedule.class_date) }}
              </v-chip>
            </div>
            <div>
              <v-icon left small>mdi-clock-outline</v-icon>
              {{ formatTime(schedule.start_time) }} -
              {{ formatTime(schedule.end_time) }}
            </div>
          </v-col>
          <v-col cols="12" md="5">
            <h4 class="mb-2">{{ schedule.classroom.name }}</h4>
            <p v-if="!isTeacherAccount">
              Teacher: {{ schedule.classroom.teacher.name }}
            </p>
            <div v-if="schedule.lessons.length > 0">
              <p>Lessons:</p>
              <ul>
                <li v-for="(lesson, j) in schedule.lessons" :key="j">
                  {{ bilingualText(lesson, 'name', 'name_cn') }}
                </li>
              </ul>
              <v-btn
                v-if="isLessonsDownloadable(schedule)"
                outlined
                color="success"
                small
                class="my-1"
              >
                <v-icon left>mdi-cloud-download</v-icon> Download Lessons
              </v-btn>
            </div>
          </v-col>
          <v-col v-if="!hideProgress" cols="12" md="2" align-self="center">
            <v-progress-linear
              color="warning"
              :value="
                (schedule.current_study_progress_count /
                  schedule.total_study_progress_count) *
                100
              "
            ></v-progress-linear>
            <h4 class="text-center">
              {{ schedule.current_study_progress_count }} /
              {{ schedule.total_study_progress_count }} completed
            </h4>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="2" class="text-right" align-self="center">
            <v-btn
              text
              color="info"
              small
              class="my-1"
              :href="$route('classroom-schedules.detail', schedule.id)"
            >
              See Details
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <div v-else class="text-center">
        <slot name="nodata">No class schedules</slot>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'ClassSchedules',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    hideProgress: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isLessonsDownloadable(schedule) {
      return (
        schedule.lessons &&
        schedule.lessons.length > 0 &&
        schedule.lessons.some((e) => e.attachment_file_url)
      )
    },
  },
}
</script>
